// Logo Formassad
function timelineFinal() {
    var logoFormassadTimeline = gsap.timeline();  
    logoFormassadTimeline
    
    //   SVG Visibility hidden 
    .set("#logo-sigle", { visibility: "visible"})     
    
    .from("#logo-sigle",{scale:0, duration:.5 , transformOrigin: "center center", ease: "back.out(1.7)"}) 

    .from("#petit-cercle",{scale:0, duration:.5 , transformOrigin: "center center",  ease: "circ.out"})
    .to("#e-03", {  duration:1.5, drawSVG: "0% 80%" }, 0) 
    .to("#e-04", {  duration:1.5,  drawSVG: "0% 70%" }, 0) 
    .from("#logo-sigle", { duration: 2, rotation: -180, transformOrigin: "center center", ease: "expo.out" }, 0) 
    
    .addLabel("label_debut", "-=1.5")  
    
    .from("#jambes", { duration: 1.75, drawSVG: "0" }, "label_debut")
    .addLabel("label_jambes", "-=1.20") 
    
    .from("#bras", { duration: 1.75, drawSVG: "0" }, "label_debut")
    .addLabel("label_bras_debut", "-=2.3") 
    .addLabel("label_bras_fin", "-=1.35")  
    
    .from("#tete", { duration: 2,scale: 0, transformOrigin: "center 20%"}, "label_debut")
    .addLabel("label_tete", "-=2.3") 
    
    .to("#e-01", { duration: 1.5, drawSVG: "0% 65%" }, "label_tete") 
    .to("#e-01", { duration: 1.5, drawSVG: "20% 65%" }, "label_bras_fin") 

    .to("#e-02", { duration: 1.5, drawSVG: "40% 100%" }, "label_bras_fin") 
    
    .to("#e-04", { duration: 1.5, drawSVG: "25% 70%" },"label_jambes") 
    
    .to("#e-05", { duration: 1.5, drawSVG: "0% 93%" }, "label_bras_debut") 
    .to("#e-05", { duration: 1.5, drawSVG: "10% 93%" }, "label_jambes") 
    
    .to("#e-06", { duration: 1.5, drawSVG: "0% 85%" }, "label_bras_debut")
    .to("#e-06", { duration: 1.5, drawSVG: "40% 80%" }, "label_tete")
    
    ;
    return logoFormassadTimeline;
}

// text formassad
function timelineText(){
    var textFormassadTimeline = gsap.timeline();
    textFormassadTimeline
        
        .set("#txt-formassad", {visibility:"visible", })
        .fromTo ("#txt-haut",
                {translateY:"100%", opacity:0, },
                {duration: 1.2, translateY:0, opacity:1, }
                )
        .fromTo ("#txt-bas",
                {translateY:"-100%", opacity:0 },
                {duration: 1.3, translateY:0, opacity:1 }
                ,"-=1.3")
        
    return textFormassadTimeline;
}

if ( jQuery('#logo-sigle').length ) {
    var master = gsap.timeline();
    master
        .add(timelineFinal())
        .add(timelineText(),"-=2.2") 
    ;   
}